// Este archivo lo incluyen varias secciones, así que puede cargarse varias veces.
// Este guard asegura que la inicialización se ejecuta una sola vez.
if (!window.__ncInit) {
  window.__ncInit = true;

  function ncArrancar() {
    initReveals();
    initComparador();
    initContadores();
    initContadorOferta();
    initResenas();
    initProducto();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ncArrancar);
  } else {
    ncArrancar();
  }
}

function initContadorOferta() {
  document.querySelectorAll('[data-nc-cuenta-atras]').forEach(function (el) {
    if (el.dataset.ncBound) return;
    el.dataset.ncBound = '1';
    var fin = new Date(el.getAttribute('data-fin')).getTime();
    if (isNaN(fin)) return;

    var seccion = el.closest('.shopify-section') || el;
    var dias = el.querySelector('[data-nc-dias]');
    var horas = el.querySelector('[data-nc-horas]');
    var minutos = el.querySelector('[data-nc-minutos]');
    var segundos = el.querySelector('[data-nc-segundos]');

    function pad(n) { return (n < 10 ? '0' : '') + n; }

    function tick() {
      var diff = fin - Date.now();
      if (diff <= 0) {
        seccion.style.display = 'none';
        clearInterval(timer);
        return;
      }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      if (dias) dias.textContent = d;
      if (horas) horas.textContent = pad(h);
      if (minutos) minutos.textContent = pad(m);
      if (segundos) segundos.textContent = pad(s);
    }

    tick();
    var timer = setInterval(tick, 1000);
  });
}

function initReveals() {
  var els = document.querySelectorAll('.nc-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('nc-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('nc-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el) { observer.observe(el); });
}

function initComparador() {
  document.querySelectorAll('[data-nc-comparador]').forEach(function (wrap) {
    if (wrap.dataset.ncBound) return;
    wrap.dataset.ncBound = '1';
    var dragging = false;

    function setClip(pct) {
      pct = Math.max(0, Math.min(100, pct));
      wrap.style.setProperty('--nc-clip', pct + '%');
    }

    function setFromEvent(e) {
      var rect = wrap.getBoundingClientRect();
      if (!rect.width) return;
      setClip(((e.clientX - rect.left) / rect.width) * 100);
    }

    wrap.addEventListener('pointerdown', function (e) {
      dragging = true;
      wrap.classList.add('is-dragging');
      try { wrap.setPointerCapture(e.pointerId); } catch (err) {}
      setFromEvent(e);
      e.preventDefault();
    });

    wrap.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      setFromEvent(e);
      e.preventDefault();
    });

    function stop(e) {
      if (!dragging) return;
      dragging = false;
      wrap.classList.remove('is-dragging');
      try { wrap.releasePointerCapture(e.pointerId); } catch (err) {}
    }
    wrap.addEventListener('pointerup', stop);
    wrap.addEventListener('pointercancel', stop);
    wrap.addEventListener('lostpointercapture', function () {
      dragging = false;
      wrap.classList.remove('is-dragging');
    });

    // Teclado (accesibilidad) a través del control de rango, si existe
    var range = wrap.querySelector('.nc-comparador-range');
    if (range) {
      range.addEventListener('input', function () { setClip(parseFloat(range.value)); });
    }

    setClip(50);
  });
}

function initResenas() {
  document.querySelectorAll('[data-nc-resena]').forEach(function (card) {
    if (card.dataset.ncBound) return;
    card.dataset.ncBound = '1';
    var btn = card.querySelector('.nc-resena-foto-btn');
    if (!btn) return;
    var track = card.closest('.nc-resenas-track');

    btn.addEventListener('click', function () {
      var abierto = card.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', abierto ? 'true' : 'false');
      if (track) {
        track.classList.toggle('has-open', !!track.querySelector('.nc-resena-card.is-open'));
      }
    });
  });
}

function initContadores() {
  var els = document.querySelectorAll('[data-nc-contador]');
  if (!els.length) return;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      observer.unobserve(el);
      var target = parseFloat(el.getAttribute('data-nc-contador'));
      var suffix = el.getAttribute('data-nc-sufijo') || '';
      if (reduced || isNaN(target)) {
        el.textContent = target + suffix;
        return;
      }
      var start = 0;
      var duration = 1400;
      var startTime = null;
      function step(ts) {
        if (!startTime) startTime = ts;
        var progress = Math.min((ts - startTime) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        var value = Math.round(start + (target - start) * eased);
        el.textContent = value + suffix;
        if (progress < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    });
  }, { threshold: 0.4 });
  els.forEach(function (el) { observer.observe(el); });
}

function initProducto() {
  var root = document.querySelector('[data-nc-producto]');
  if (!root) return;

  var thumbs = root.querySelectorAll('[data-nc-thumb]');
  var mainImg = root.querySelector('[data-nc-imagen-principal]');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (!mainImg) return;
      mainImg.src = thumb.getAttribute('data-nc-full') || thumb.src;
      mainImg.srcset = '';
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  var variantsJson = root.querySelector('[data-nc-variantes]');
  var variants = variantsJson ? JSON.parse(variantsJson.textContent) : [];
  var optionInputs = root.querySelectorAll('[data-nc-opcion]');
  var idInput = root.querySelector('[data-nc-variant-id]');
  var priceEl = root.querySelector('[data-nc-precio]');
  var compareEl = root.querySelector('[data-nc-precio-comparado]');
  var addBtn = root.querySelector('[data-nc-add]');

  function currentSelection() {
    var sel = [];
    optionInputs.forEach(function (group) {
      var checked = group.querySelector('input:checked');
      if (checked) sel.push(checked.value);
    });
    return sel;
  }

  function money(cents) {
    return (cents / 100).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' });
  }

  function updateVariant() {
    if (!variants.length) return;
    var sel = currentSelection();
    var match = variants.find(function (v) {
      return v.options.every(function (opt, i) { return !sel[i] || opt === sel[i]; });
    });
    if (!match) return;
    if (idInput) idInput.value = match.id;
    if (priceEl) priceEl.textContent = money(match.price);
    if (compareEl) {
      if (match.compare_at_price && match.compare_at_price > match.price) {
        compareEl.textContent = money(match.compare_at_price);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }
    if (addBtn) {
      addBtn.disabled = !match.available;
      addBtn.textContent = match.available ? addBtn.getAttribute('data-nc-texto-disponible') : addBtn.getAttribute('data-nc-texto-agotado');
    }
  }

  optionInputs.forEach(function (group) {
    group.addEventListener('change', updateVariant);
  });
  updateVariant();
}
